import type { Publication } from "@rowan/prisma";
import { createContext } from "react";

export interface ContentsItem {
  id: string;
  type: string;
  label: string;
  menuType?: string;
  name?: string;
  children?: ContentsItem[];
  chunkReference?: string;
  annotations?: number;
  bookmarks?: number;
  bookmarkCollectionColours?: string[];
  ownBookmarkCollectionColours?: string[];
}

type PublicationContextType = {
  contents?: ContentsItem[];
  styles?: string;
  chapters?: Record<string, string>;
  publication: Publication;
  htmlChunks?: Record<number, string>;
  chapterId?: string;
  publicationSlug?: string;
  currentSection?: ContentsItem;
  selectSection: (
    id: string,
    section?: ContentsItem,
    noScroll?: boolean,
  ) => void;
  currentChunk?: string;
  selectByHash: (hash: string) => void;
  scrollDisabled?: boolean;
  setScrollDisabled: (disable: boolean) => void;
  scrollSnippet?: string;
  setScrollSnippet: (snippet: string | undefined) => void;
  pendingHash?: string;
  setPendingHash: (hash: string | undefined) => void;
  containerRef: React.RefObject<HTMLDivElement | null>;
};

export const PublicationContext = createContext<PublicationContextType>({
  contents: undefined,
  styles: undefined,
  chapters: undefined,
  publication: null as unknown as Publication,
  htmlChunks: undefined,
  chapterId: undefined,
  publicationSlug: undefined,
  currentSection: undefined,
  selectByHash: () => {},
  selectSection: () => {},
  currentChunk: undefined,
  scrollDisabled: undefined,
  setScrollDisabled: () => {},
  scrollSnippet: undefined,
  setScrollSnippet: () => {},
  setPendingHash: () => {},
  containerRef: { current: null },
});
